import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResourceHandler } from '@ngx-resource/core';
import { ResourceHandlerHttpClient } from './src/ResourceHandlerHttpClient';
export * from './src/ResourceHandlerHttpClient';
var ResourceModule = /** @class */ (function () {
    function ResourceModule() {
    }
    /**
     * For root
     * @param {IResourceModuleConfig} config
     * @return {ModuleWithProviders}
     */
    /**
       * For root
       * @param {IResourceModuleConfig} config
       * @return {ModuleWithProviders}
       */
    ResourceModule.forRoot = /**
       * For root
       * @param {IResourceModuleConfig} config
       * @return {ModuleWithProviders}
       */
    function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: ResourceModule,
            providers: [
                config.handler || { provide: ResourceHandler, useClass: ResourceHandlerHttpClient, deps: [HttpClient] }
            ]
        };
    };
    /**
     * For child
     * @param {IResourceModuleConfig} config
     * @return {ModuleWithProviders}
     */
    /**
       * For child
       * @param {IResourceModuleConfig} config
       * @return {ModuleWithProviders}
       */
    ResourceModule.forChild = /**
       * For child
       * @param {IResourceModuleConfig} config
       * @return {ModuleWithProviders}
       */
    function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: ResourceModule,
            providers: [
                config.handler || { provide: ResourceHandler, useClass: ResourceHandlerHttpClient, deps: [HttpClient] }
            ]
        };
    };
    ResourceModule.decorators = [
        { type: NgModule },
    ];
    return ResourceModule;
}());
export { ResourceModule };
